module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_1-37154fe546aa234f038329bb864114c2.jpg";